<p>
  <strong
    >It is not recommended to initiate manual proofing if you are able to
    complete remote proofing,</strong
  >
  as manual proofing takes longer to complete.
</p>
<p>
  To initiate manual proofing, you will need to complete the following steps:
</p>
<ol>
  <li>
    Submit your Profile Information and Account Information via HARP (SSN field
    is optional)
  </li>
  <li>
    Send the following documents to the Services and Operations Support (SOS)
    team via email, fax, or mail
  </li>
  <ul>
    <li>
      <strong>One</strong> of three approved forms of Government Photo IDs:
    </li>
    <ul>
      <li>Current driver's license issued by state or territory; OR</li>
      <li>Federal or State government issued photo identification card; OR</li>
      <li>U.S. Passport</li>
    </ul>
    <li>
      <strong>Two</strong> copies of financial institution official bills or
      statements addressed to the address used during the registration process.
      Payroll information is also accepted.
    </li>
    <li>
      If you choose not to fill out the HARP SSN field, you will need to provide
      only the <strong>last four digits of your SSN</strong> to the SOS team.
    </li>
  </ul>
</ol>
<p>
  The Services and Operations Support (SOS) team will contact you via email if
  they need to request additional information.
</p>
<p>
  For any questions related to manual proofing, contact the Services and
  Operations Support (SOS) team, Monday - Friday 8:00 AM - 8:00 PM EST by phone
  1-866-288-8914 or email
  <a href="mailto:identity.proofing@cms.hhs.gov"
    >identity.proofing&#64;cms.hhs.gov</a
  >.
</p>
<div class="alert alert-info">
  <strong>Note:</strong> Do not initiate manual proofing if you are a CMS
  employee. CMS employees may bypass HARP registration and use their EUA
  credentials to log into HARP.
</div>
